import * as Types from '../constants/actionTypes';

export default (state = {
  additionalInfo: [],
  additionalInfoList: []
}, action) => {
    // console.log(`state in auth is :`,state);
   switch (action.type) {
     case Types.ADDITIONAL_INFO_SUCCESS: {
       return {
         ...state,
         additionalInfo: action.payload
       }
     }
     case Types.ADDITIONAL_INFO_ADDED_SUCCESS: {
      return {
        ...state,
        additionalInfo: action.payload
      }
    }   
    case Types.ADDITIONAL_INFO_ERROR:
      return {
        ...state,
        additionalInfoError: action.additionalInfoError
      }
      case Types.ADDITIONAL_INFO_COUNT_SUCCESS:
        return Object.assign({}, state, { additionalInfoCount: action.payload})
      case Types.ADDITIONAL_INFO_UPDATE_SUCCESS:
        const updateIndex = state.additionalInfo.findIndex((data) => { return  data.id === action.payload.id} );
        if(updateIndex> -1) {
          state.additionalInfo[updateIndex] = action.payload
        }
        return {
          ...state
        }
        case Types.ADDITIONAL_INFO_DELETED_SUCCESS:
          const newList = state.additionalInfo.filter((data) => data.id !== action.payload )
          return {
            ...state,
            additionalInfo : newList,
            deletedAddtionalInfoStatus:action.payload
          }
     default:
       return state;
   }
  };